import {
  AppDispatch,
  getClientOrganizationListRequest,
  sendSlaEmail,
  sendSlaEmailClear,
  sendSlaEmailRequest,
  toggleRequireSlaAgreement,
  toggleRequireSlaAgreementClear,
  toggleRequireSlaAgreementRequest,
  updateOrganization,
  updateOrganizationClear,
  updateOrganizationRequest,
} from "@src/redux";
import { Button, Col, Form, Row, Switch } from "antd";
import { log } from "console";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

interface SlaAgreementCardProps {
  onCancel: () => void; // Ensure it's a function type
  name?: string;
  client?: any;
}

const SlaAgreementCard: React.FC<SlaAgreementCardProps> = ({
  onCancel,
  client,
  name,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const { result: updateOrgResult, loading: updateOrgLoading } =
    useSelector(toggleRequireSlaAgreement);
  const { result: sentMailResult, loading: sentMailResultLoading } =
    useSelector(sendSlaEmail);

  const handleSentSlaMail = () => {
    dispatch(
      sendSlaEmailRequest({
        id: client?.id || "",
      })
    );
  };
  const handleClose = () => {
    onCancel();
    form.resetFields();
  };

  const handleChangeSwitch = (value: boolean) => {
    dispatch(
      toggleRequireSlaAgreementRequest({
        id: client?.id || "",
      })
    );
  };

  useEffect(() => {
    if (sentMailResult?.status === "success") {
      toast.success(t("sla_agreement_mail_sended_successfully"));
      handleClose();
      dispatch(sendSlaEmailClear());
      dispatch(toggleRequireSlaAgreementClear());
      dispatch(
        getClientOrganizationListRequest({
          filter: {},
          pagination: {
            pageNumber: 1,
            pageLimit: 10,
          },
          sort: [
            {
              field: "name",
              order: "asc",
            },
          ],
        })
      );
    } else if (sentMailResult?.error?.message) {
      toast.error(sentMailResult?.error?.message);
      dispatch(sendSlaEmailClear());
    }
  }, [sentMailResult]);

  useEffect(() => {
    if (client) {
      form.setFieldsValue({ isSlaAccepted: client.isSlaAccepted });
    }
  }, [client]);

  useEffect(() => {
    form.resetFields();
  }, [name]);

  return (
    <div>
      {/* <p>{`Are you sure you want to ${
        client?.requireSlaAcceptance ? "disable" : "enable"
      } need for SLA Acceptance for"${client?.name}"?`}</p> */}
      <Form form={form}>
        <Row gutter={10}>
          <Col span={12}>
            <span>{t("required_sla_agreement")}</span>
          </Col>
          <Col span={12} style={{ textAlign: "end" }}>
            <Form.Item
              noStyle
              initialValue={client?.isSlaAccepted}
              name={"isSlaAccepted"}
            >
              <Switch
                onChange={handleChangeSwitch}
                loading={updateOrgLoading}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Button
          style={{ marginRight: "10px" }}
          onClick={handleClose}
          type="default"
          danger
        >
          {t("close")}
        </Button>
        {updateOrgResult?.status === "success" && (
          <Button
            type="primary"
            onClick={handleSentSlaMail}
            loading={sentMailResultLoading}
          >
            {t("sent_mail")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SlaAgreementCard;
